var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCf3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(-860 -1003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    transform: "translate(860 1003)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "money_4_",
    "data-name": "money (4)",
    transform: "translate(863 984.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M40.742,48.493H1.94A1.946,1.946,0,0,1,0,46.553V25.212a1.946,1.946,0,0,1,1.94-1.94h38.8a1.946,1.946,0,0,1,1.94,1.94V46.553A1.946,1.946,0,0,1,40.742,48.493Z",
    fill: "#0e9347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M260.951,232.727a6.493,6.493,0,0,0-5.432,2.813,7.236,7.236,0,0,0-3.3-.873,6.787,6.787,0,0,0-6.693,5.82H265.8a1.973,1.973,0,0,0,1.94-1.649A6.91,6.91,0,0,0,260.951,232.727Z",
    transform: "translate(-225.059 -191.994)",
    fill: "#0d8944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M58.195,67.887H27.153a3.892,3.892,0,0,0-3.88-3.88V50.426a3.892,3.892,0,0,0,3.88-3.88H58.195a3.892,3.892,0,0,0,3.88,3.88V64.007A3.892,3.892,0,0,0,58.195,67.887Z",
    transform: "translate(-21.333 -21.334)",
    fill: "#3bb54a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(7.76 27.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M267.351,232.727a6.492,6.492,0,0,0-5.432,2.813,7.236,7.236,0,0,0-3.3-.873,6.664,6.664,0,0,0-6.111,3.88h15.812a3.871,3.871,0,0,1,3.783-3.88A7.012,7.012,0,0,0,267.351,232.727Z",
    transform: "translate(-239.219 -219.146)",
    fill: "#0e9347"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 7.76,
    cy: 8.73,
    rx: 7.76,
    ry: 8.73,
    transform: "translate(5.82)",
    fill: "#0e9347"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 1.94,
    cy: 1.94,
    r: 1.94,
    transform: "translate(0 6.79)",
    fill: "#0e9347"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 1.94,
    cy: 1.94,
    r: 1.94,
    transform: "translate(23.281 6.79)",
    fill: "#0e9347"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M214.305,109.579h-1.94a.97.97,0,0,1,0-1.94h2.91a.97.97,0,1,0,0-1.94h-.97a.97.97,0,0,0-1.94,0,2.91,2.91,0,1,0,0,5.82h1.94a.97.97,0,1,1,0,1.94H211.4a.97.97,0,1,0,0,1.94h.97a.97.97,0,0,0,1.94,0,2.91,2.91,0,0,0,0-5.82Z",
    transform: "translate(-191.994 -74.666)",
    fill: "#89c763"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 6.79,
    cy: 6.79,
    r: 6.79,
    transform: "translate(18.431 42.673)",
    fill: "#ffca5d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 6.79,
    cy: 6.79,
    r: 6.79,
    transform: "translate(27.161 40.733)",
    fill: "#f6b545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M332.608,232.727a6.79,6.79,0,1,0,6.79,6.79A6.749,6.749,0,0,0,332.608,232.727Zm0,11.641a4.85,4.85,0,1,1,4.85-4.85A4.8,4.8,0,0,1,332.608,244.368Z",
    transform: "translate(-298.657 -191.994)",
    fill: "#ffcb5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M407.273,320.875h0a6.667,6.667,0,0,0,6.79-6.693h-.1a1.032,1.032,0,0,0-.97.873,5.865,5.865,0,0,1-1.843,3.492A5.5,5.5,0,0,1,408.146,320,.869.869,0,0,0,407.273,320.875Z",
    transform: "translate(-373.321 -266.659)",
    fill: "#f6b545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M332.608,233.867h0a6.667,6.667,0,0,0-6.79,6.693h.1a1.031,1.031,0,0,0,.97-.873,5.865,5.865,0,0,1,1.843-3.492,5.5,5.5,0,0,1,3.007-1.455A.869.869,0,0,0,332.608,233.867Z",
    transform: "translate(-298.657 -193.037)",
    fill: "#ffe27a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M349.77,261.529a4.8,4.8,0,0,1,4.85-4.85,4.575,4.575,0,0,1,3.1,1.164,4.835,4.835,0,0,0-8.633,3.007,4.651,4.651,0,0,0,1.746,3.686A4.549,4.549,0,0,1,349.77,261.529Z",
    transform: "translate(-319.989 -213.327)",
    fill: "#f19920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M437.382,311.856a.356.356,0,0,1-.291-.1.469.469,0,0,1,0-.679,3.238,3.238,0,0,0,.873-2.231.485.485,0,1,1,.97,0,4.479,4.479,0,0,1-1.067,2.91A1.055,1.055,0,0,1,437.382,311.856Z",
    transform: "translate(-400.52 -261.326)",
    fill: "#ffcb5b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(27.258 42.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M396.607,285.094a.916.916,0,0,1-.97-.97v-3.88a.97.97,0,0,1,1.94,0v3.88A.916.916,0,0,1,396.607,285.094Z",
    transform: "translate(-389.914 -277.334)",
    fill: "#f19920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M337.264,266.574a7.882,7.882,0,0,0-4.656-5.238A8.11,8.11,0,0,0,328.921,256a7.012,7.012,0,0,0-1.94,4.753,6.749,6.749,0,0,0,6.79,6.79A5.626,5.626,0,0,0,337.264,266.574Z",
    transform: "translate(-326.981 -256)",
    fill: "#f19920"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(29.101 43.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M350.836,278.4a5.1,5.1,0,0,1-1.164-3.1,4.7,4.7,0,0,1,1.552-3.492,4.218,4.218,0,0,0-.582-.679,4.752,4.752,0,0,0-1.552,3.589A4.651,4.651,0,0,0,350.836,278.4Z",
    transform: "translate(-349.09 -271.128)",
    fill: "#e78825"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M395.636,321.164v1.358a.97.97,0,0,0,1.94,0v-.194A7.926,7.926,0,0,0,395.636,321.164Z",
    transform: "translate(-391.756 -316.993)",
    fill: "#e78825"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M336.2,267.639a6.2,6.2,0,0,0-.776-1.843,4.694,4.694,0,0,1-2.813.97,4.8,4.8,0,0,1-4.85-4.85,4.752,4.752,0,0,1,1.552-3.589,5.917,5.917,0,0,0-1.552-1.164,7.012,7.012,0,0,0-1.94,4.753,6.749,6.749,0,0,0,6.79,6.79A6.5,6.5,0,0,0,336.2,267.639Z",
    transform: "translate(-298.657 -214.392)",
    fill: "#f6b545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M410.57,372.364a6.706,6.706,0,0,1-2.425.97,1.032,1.032,0,0,0-.873.97h0a6.505,6.505,0,0,0,3.589-1.067Z",
    transform: "translate(-373.32 -319.99)",
    fill: "#f19920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M327.758,257.164a7.012,7.012,0,0,0-1.94,4.753h.1a1.031,1.031,0,0,0,.97-.873,6.036,6.036,0,0,1,1.746-3.4A3.935,3.935,0,0,1,327.758,257.164Z",
    transform: "translate(-298.657 -214.394)",
    fill: "#ffcb5b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 6.79,
    cy: 6.79,
    r: 6.79,
    transform: "translate(18.431 42.673)",
    fill: "#f6b545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M290.909,320.971a6.722,6.722,0,0,0,.291,1.94h.679a6.767,6.767,0,0,0,6.5-8.73H297.7A6.749,6.749,0,0,0,290.909,320.971Z",
    transform: "translate(-266.658 -266.658)",
    fill: "#f19920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M227.88,256a6.79,6.79,0,1,0,6.79,6.79A6.749,6.749,0,0,0,227.88,256Zm0,11.641a4.85,4.85,0,1,1,4.85-4.85A4.8,4.8,0,0,1,227.88,267.641Z",
    transform: "translate(-202.659 -213.327)",
    fill: "#ffcb5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M302.545,344.148h0a6.667,6.667,0,0,0,6.79-6.693h-.1a1.032,1.032,0,0,0-.97.873,5.865,5.865,0,0,1-1.843,3.492,5.5,5.5,0,0,1-3.007,1.455A.869.869,0,0,0,302.545,344.148Z",
    transform: "translate(-277.324 -287.991)",
    fill: "#f6b545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M227.88,257.14h0a6.667,6.667,0,0,0-6.79,6.693h.1a1.032,1.032,0,0,0,.97-.873A5.865,5.865,0,0,1,224,259.468a5.5,5.5,0,0,1,3.007-1.455A.869.869,0,0,0,227.88,257.14Z",
    transform: "translate(-202.659 -214.369)",
    fill: "#ffe27a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M245.042,284.8a4.8,4.8,0,0,1,4.85-4.85,4.575,4.575,0,0,1,3.1,1.164,4.835,4.835,0,0,0-8.633,3.007,4.651,4.651,0,0,0,1.746,3.686A4.55,4.55,0,0,1,245.042,284.8Z",
    transform: "translate(-223.992 -234.66)",
    fill: "#f19920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M332.655,335.128a.356.356,0,0,1-.291-.1.469.469,0,0,1,0-.679,3.238,3.238,0,0,0,.873-2.231.485.485,0,1,1,.97,0,4.479,4.479,0,0,1-1.067,2.91A1.054,1.054,0,0,1,332.655,335.128Z",
    transform: "translate(-304.524 -282.658)",
    fill: "#ffcb5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M291.879,308.367a.916.916,0,0,1-.97-.97v-3.88a.97.97,0,1,1,1.94,0v3.88A.916.916,0,0,1,291.879,308.367Z",
    transform: "translate(-266.658 -255.994)",
    fill: "#f19920"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(23.281 47.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M296.342,314.278a5.673,5.673,0,0,1,.388,1.843,4.8,4.8,0,0,1-4.85,4.85,3.3,3.3,0,0,1-.97-.1v.1a6.723,6.723,0,0,0,.291,1.94h.679a6.767,6.767,0,0,0,6.5-8.731H297.7A6.41,6.41,0,0,0,296.342,314.278Z",
    transform: "translate(-289.94 -314.181)",
    fill: "#f6b545"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 6.79,
    cy: 6.79,
    r: 6.79,
    transform: "translate(0 0.97)",
    fill: "#f6b545"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M286.062,325.818a6.79,6.79,0,1,0,6.79,6.79A6.749,6.749,0,0,0,286.062,325.818Zm0,11.641a4.85,4.85,0,1,1,4.85-4.85A4.8,4.8,0,0,1,286.062,337.459Z",
    transform: "translate(-255.991 -277.325)",
    fill: "#ffcb5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M360.727,413.966h0a6.667,6.667,0,0,0,6.79-6.693h-.1a1.032,1.032,0,0,0-.97.873,5.865,5.865,0,0,1-1.843,3.492,5.5,5.5,0,0,1-3.007,1.455A.869.869,0,0,0,360.727,413.966Z",
    transform: "translate(-330.655 -351.989)",
    fill: "#f6b545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M286.062,326.958h0a6.667,6.667,0,0,0-6.79,6.693h.1a1.031,1.031,0,0,0,.97-.873,5.865,5.865,0,0,1,1.843-3.492,5.5,5.5,0,0,1,3.007-1.455A.869.869,0,0,0,286.062,326.958Z",
    transform: "translate(-255.991 -278.367)",
    fill: "#ffe27a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M303.224,354.62a4.8,4.8,0,0,1,4.85-4.85,4.575,4.575,0,0,1,3.1,1.164,4.835,4.835,0,0,0-8.633,3.007,4.651,4.651,0,0,0,1.746,3.686A4.549,4.549,0,0,1,303.224,354.62Z",
    transform: "translate(-277.324 -298.657)",
    fill: "#f19920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M390.836,404.946a.356.356,0,0,1-.291-.1.469.469,0,0,1,0-.679,3.237,3.237,0,0,0,.873-2.231.485.485,0,0,1,.97,0,4.479,4.479,0,0,1-1.067,2.91A1.054,1.054,0,0,1,390.836,404.946Z",
    transform: "translate(-357.855 -346.655)",
    fill: "#ffcb5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M350.061,378.184a.916.916,0,0,1-.97-.97v-3.88a.97.97,0,1,1,1.94,0v3.88A.916.916,0,0,1,350.061,378.184Z",
    transform: "translate(-319.989 -319.99)",
    fill: "#f19920"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf3);
export default __webpack_public_path__ + "static/media/cf3.af4f05eac08c111e1c723436812ae0ba.svg";
export { ForwardRef as ReactComponent };